jQuery(document).ready(function($) {

$("form.enter-details:not(.finalize)").validate({
    rules: {
      lastName: {
          required: true,
          minlength: 2,
      },
      gender: {
          required: true,
      },
      middleName: {
          minlength: 2,
      },
      initials: {
          required: true,
          lettersonly: true,
          minlength: 1,
      },
      zipcode: {
          required: true,
          postalcodeNL: true,
      },
      houseNumber: {
          required: true,
          digits: true,
      },
      houseNumberAddition: {
          maxlength: 8,
      },
      street: {
          required: true,
      },
      city: {
          required: true,
      },
      phone: {
        required: true,
        phoneNL: true,
      },
      dob: {
        required: true,
        dateNL: true,
      },
      // incentive: {
      //   required: true,
      // },
      // bank_iban: {
      //   required: function(element){
      //       return $('select[name="incentive"] option:checked').attr('data-type') == '1';
      //   },
      //   iban: true,
      // },
      // bank_fullname: {
      //   required: function(element){
      //       return $('select[name="incentive"] option:checked').attr('data-type') == '1';
      //   }
      // },
      she_number: {
        required: function(element){
            return $('input[name="variable_field"]').val() !== '' && $('input[name="variable_field"]').val() !== 'null';
        }
      },
      first_invoice_number: {
          required: true,
      },
      invoice_paid: {
          required: true,
      },
      email: {
        required: true,
        email: true
      },
    },
    errorPlacement: function(label, element) {
      label.addClass('error');
      if(element.is(':radio')) {
          element.parent().parent().append(label);
      } else {
          element.parent().append(label);
      }
    },
    submitHandler: function(form) {
        form.submit();
    },
    invalidHandler: function(event, validator) {
        console.log('invalidhandler');
        // $('form.auto-samenstellen').find('#submit,#submit_mob').find('span').show();
        // $('form.auto-samenstellen').find('#submit,#submit_mob').find('.lds-ring').hide();
      }
  });


  $("form.enter-details.finalize").validate({
      ignore: [],	
      rules: {
        'incentive[]': {
          required: true,
          // minlength: window.NumIncentives,
        },
	product: {
	  required: true,
	},
        subincentive: {
          required: function(element){
              return $('input[name="has_subincentives"]').val() == '1';
          },
        },
        subincentive_date: {
          required: function(element){
              return $('input[name="has_subincentives"]').val() == '1';
          },
          dateNL: true,
        },
        bank_iban: {
          required: function(element){
              return $('input[name="incentive"]').parent().find('input:checked').attr('data-type') == '1';
          },
          iban: true,
        },
        bank_fullname: {
          required: function(element){
              return $('input[name="incentive"]').parent().find('input:checked').attr('data-type') == '1';
          }
        },
      },
      errorPlacement: function(label, element) {
        label.addClass('error');
        if(element.is(':radio') || element.is(':checkbox')) {
            element.parent().parent().parent().append(label);
        } else {
            element.parent().append(label);
        }
      },
      submitHandler: function(form) {
        window.NumIncentives = $('input[name="num_incentives"]').val() == '0' ? $('._ajax-product:visible').length : $('input[name="num_incentives"]').val();
          form.submit();
      },
      messages: { 
        'incentive[]': {
          minlength: function () {
              return [
                  'Je dient minimaal '+(window.NumIncentives) +' cadeau\'s te kiezen'
                ];
          }
}     },
      invalidHandler: function(event, validator) {

        window.NumIncentives = $('input[name="num_incentives"]').val() == '0' ? $('._ajax-product:visible').length : $('input[name="num_incentives"]').val();

        console.log(window.NumIncentives);

          console.log('invalidhandler');
        }
    });

    // jQuery('[name="incentive[]"]:visible').each(function() {

    //   console.log(window.NumIncentives);
    //   jQuery(this).rules('add', {
    //       require_from_group: [window.NumIncentives, jQuery('[name="incentive[]"]:visible')]
    //   });
    // });

});
